"use client";

import React from "react";
import FollowupQueryButton from "@/components/followup-query-button";
import { type FollowupQuery } from "@/lib/followup-parser";

interface FollowupQueriesProps {
  queries: FollowupQuery[];
  onQueryClick: (query: string) => void;
  disabled: boolean;
  hidden: boolean;
}

export default function FollowupQueries({ queries, onQueryClick, disabled, hidden }: FollowupQueriesProps) {
  // Don't render if hidden or no queries
  if (hidden || queries.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {queries.map((query, index) => (
        <FollowupQueryButton
          key={`${query.decoded}-${index}`}
          query={query}
          onClick={onQueryClick}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
